import { Typography } from "@mui/material";
import {
  formatIsoDateTime,
  formatIsoDateTimeShort,
  zoneAbbreviation,
} from "utils/dateUtils";

/**
 * Run timestamp honoring the timezone display mode: the time itself is
 * rendered in ``timeZone`` (undefined = browser-local), optionally followed
 * by the grey zone abbreviation ("CDT", "UTC") - used in Client mode where
 * every row may sit in a different zone.
 */
export default function RunTimestamp({
  iso,
  timeZone,
  showAbbreviation = false,
  short = false,
  color,
}: {
  iso: string;
  timeZone?: string;
  showAbbreviation?: boolean;
  short?: boolean;
  color?: string;
}) {
  const text = short
    ? formatIsoDateTimeShort(iso, timeZone)
    : formatIsoDateTime(iso, timeZone);
  return (
    <Typography
      variant="body2"
      component="span"
      noWrap
      color={color}
      title={formatIsoDateTime(iso, timeZone)}
    >
      {text}
      {showAbbreviation && (
        <Typography
          component="span"
          variant="caption"
          color="text.secondary"
          sx={{ ml: 0.5 }}
        >
          {zoneAbbreviation(iso, timeZone)}
        </Typography>
      )}
    </Typography>
  );
}
